import { makeStyles, Theme, createStyles, useMediaQuery } from "@material-ui/core";
import { useContext } from "react";
import { RootContext } from "../../stores";
import { observer } from "mobx-react";
import ThemedDialogWithSpinner from "../Shared/Dialogs/ThemedDialogWithSpinner";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        secondaryAction: {
            backgroundColor: theme.palette.darkBackground.light,
            color: theme.palette.darkBackground.contrastText
        }
    }),
);

const VolunteerAccountRequiredDialog = observer(() => {

    /********** React hooks **********/

    const classes = useStyles();
    const rootStore = useContext(RootContext);
    const userStore = rootStore.userStore;
    const user = userStore.user;
    const xsDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

    /********** Helper constants **********/

    const dialogState = rootStore.navigationStore.appwideDialogStates.volunteerAccountRequiredDialog;

    /********** Event handlers **********/

    const handleSwitchToVolunteerProfile = async () => {
        const userVolunteerProfile = user.volunteerProfile;
        if (userVolunteerProfile?.id !== undefined) {
            await userStore.updateUserProfileStatus(user.id, userVolunteerProfile.id, 'active');
        }
        dialogState.setOpen(false);
    }

    const handleLogout = () => {
        dialogState.setOpen(false);
        rootStore.navigationStore.appwideDialogStates.logoutDialog.setOpen(true);
    }

    /********** Render **********/

    return (
        <ThemedDialogWithSpinner
            title={'Volunteer Account Required'}
            primaryButtonProps={user.hasVolunteerProfile ? { children: 'Switch Profile', variant: 'contained', onClick: handleSwitchToVolunteerProfile } : { children: 'Logout' }}
            extraButtonProps={
                user.hasVolunteerProfile
                    ? [{
                        children: 'Logout',
                        variant: 'contained',
                        className: classes.secondaryAction,
                        onClick: handleLogout
                    }]
                    : undefined
            }
            state={dialogState}
            DialogProps={{ fullScreen: xsDown, maxWidth: 'xs' }}
            onSubmit={user.hasVolunteerProfile ? handleSwitchToVolunteerProfile : handleLogout}
        >
            <Alert severity="info">
                <AlertTitle>Switch to a volunteer account to continue.</AlertTitle>
                {user.hasVolunteerProfile
                    ? "You're using an organization administrator profile right now. In order to take this action, please switch to your volunteer profile or logout and log back in to another volunteer account."
                    : "You're logged into your organization's account at the moment. Please logout and then log back in as a volunteer in order to take this action."
                }
            </Alert>
        </ThemedDialogWithSpinner >
    );
});

export default VolunteerAccountRequiredDialog;